 
import { Component, OnInit, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-lt-autocomplete',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
  ],
  template: `
    @if(items() !== null && items()?.length > 0)
    {
      <mat-form-field appearance="fill">
        @if(label())
        {
          <mat-label>{{label()}}</mat-label>
        }
        <input type="text"
          matInput
          [placeholder]="placeholder()"
          [required]="required()"
          [disabled]="disabled()"
          [matAutocomplete]="auto"
          [formControl]="itemFormControl">
        <mat-autocomplete autoActiveFirstOption
            #auto="matAutocomplete"
            (optionSelected)="onOptionSelected($event.option.value)"
            [displayWith]="displayFn">
          
          @for(option of filteredItems$ | async; track $index) {
              <mat-option [value]="option">
                {{itemDisplayFn(option)}}
              </mat-option>
            }
        </mat-autocomplete>
      </mat-form-field>
    }
  `,
  styles: '',
})
export class LtAutocompleteComponent implements OnInit {
  label = input<string>('Select');
  placeholder = input('Search...');
  disabled = input(false);
  required = input(false);
  noItemsMessage = input<string>('No items available.');
  items = input<any[]>([]);
  overrideId = input<any>();
  overrideIdField = input<string | keyof any>();
  overrideItem = input<any>();

  displayWithFn = input<(item: any) => string>();
  itemTemplateFn = input<(item: any) => string>();
  showSelectedItemChange = input<boolean>(false);

  itemSelected = output<any>();
  loadingFailed = output<void>();
  itemSelectedFromOverride = output<any>();

  itemFormControl = new UntypedFormControl('');
  filteredItems$!: Observable<any[]>;

  displayFn = (item: any): string => {
    const fn = this.displayWithFn();
    return item ? fn(item): '';
  };

  itemDisplayFn = (item: any): string => {
    const fn = this.itemTemplateFn();
    return item ? fn(item): '';
  };

  ngOnInit(): void {
    this.filteredItems$ = this.itemFormControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value.toLowerCase() : this.displayWithFn()(value).toLowerCase()),
      map(name => this.filterOptions(name)),
    );

    if (this.overrideId && this.overrideIdField)
    {
      const match = this.items().find(x => x[this.overrideIdField()!] === this.overrideId);
      if (match)
      {
        this.itemFormControl.setValue(match);
        this.selectItemForOverride(match);
      }
    }
    else if (this.overrideItem() != null)
    {
      this.itemFormControl.setValue(this.overrideItem());
      this.selectItemForOverride(this.overrideItem());
    }
  }

  onOptionSelected(item: any): void {
    this.itemSelected.emit(item);
  }

  selectItemForOverride(item: any): void {
    this.itemSelectedFromOverride.emit(item);
  }

  filterOptions(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.items().filter(option => this.displayWithFn()(option).toLowerCase().includes(filterValue));
  }
}
